import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const ProcedimientoReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Validar un procedimiento
   */
  builder
    .addCase(Types.VALIDAR_PROCEDIMIENTO_LOADING, (state) => {
      state.validarProcedimientoLoading = true;
      state.validarProcedimientoError = null;
    })
    .addCase(Types.VALIDAR_PROCEDIMIENTO_SUCCESS, (state, action) => {
      const { validarProcedimientoData } = action;
      state.validarProcedimientoData = validarProcedimientoData;
      state.validarProcedimientoLoading = false;
      state.validarProcedimientoError = null;
    })
    .addCase(Types.VALIDAR_PROCEDIMIENTO_FAILURE, (state, action) => {
      const { validarProcedimientoError } = action;
      state.validarProcedimientoData = INITIAL_STATE.validarProcedimientoData;
      state.validarProcedimientoLoading = false;
      state.validarProcedimientoError = validarProcedimientoError;
    });

  /**
   * Eliminar un procedimiento
   */
  builder
    .addCase(Types.ELIMINAR_PROCEDIMIENTO_LOADING, (state) => {
      state.eliminarProcedimientoLoading = true;
      state.eliminarProcedimientoError = null;
    })
    .addCase(Types.ELIMINAR_PROCEDIMIENTO_SUCCESS, (state, action) => {
      const { eliminarProcedimientoData } = action;
      state.eliminarProcedimientoData = eliminarProcedimientoData;
      state.eliminarProcedimientoLoading = false;
      state.eliminarProcedimientoError = null;
    })
    .addCase(Types.ELIMINAR_PROCEDIMIENTO_FAILURE, (state, action) => {
      const { eliminarProcedimientoError } = action;
      state.eliminarProcedimientoData = INITIAL_STATE.eliminarProcedimientoData;
      state.eliminarProcedimientoLoading = false;
      state.eliminarProcedimientoError = eliminarProcedimientoError;
    });
});
